<template>
    <div class="BillKassa">
		<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Объектов найдено: {{this.masObjects_total}}</span>
		</div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="billing"
			/>
		</div>
		<div class="my-2" v-if="this.$GVO.my_profile.PayMaster == 1 || this.$GVO.my_profile.adm == 1">
			<ReReportForm
				:objGetParams="objGetParams"
				obj="billing"
			/>
		</div>
		<!-- <div class="d-flex flex-wrap my-3" v-if="this.$GVO.my_profile.PayMaster == 1 || this.$GVO.my_profile.adm == 1 ">
			<div class="mr-md-3">
				<h6 class="mb-1">Формирование отчета</h6>	
				<p>Задайте фильтром выше нужные Вам параметры и загрузите отчет в Excel</p>
			</div>
			<base-button   
				@click="reportDownload()" 
				class="btn-simple btn-success my-0" 
			>Скачать <i class="fa fa-file-excel ml-1"></i></base-button>
		</div> -->
		<div class="row px-3">		
			<card class="post post-sticky mt-2 focus-shadow">
				<div class="py-3">
					<h5><i class="tim-icons icon-send text-success mr-3"></i>Внести деньги</h5>
				</div>
				<div class="postAddForm">		
					<form class="form-container">
						<div class="row justify-content-between align-items-center">  
								<div class="col-md mb-3 ">
									<!-- <ReInputMask v-model="amount" mask="money" placeholder="Сумма" /> -->
									<re-input-amount v-model="amount" mask="money" placeholder="Сумма" />
								</div>
								<div class="col-md mb-3">
								<ReInputSearchDrop
									:findId="'agent_id'"
									:placeholder="'Выбрать сотрудника'"
									v-model="staff_code"
									:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
									:strApiMethodKey="'fio'"
									@change="onAgentChange"
								/></div>
								<div class="col-md mb-3 mt-2">
									<base-input
									placeholder="Примечание"
									v-model="comment"
									autocomplete="off"
									></base-input>
								</div>

							<div class="d-flex px-3 mb-3">
								<base-button type="success" simple @click="INS_PAYMENT()"><i class="tim-icons icon-send mr-2"></i>Оплатить</base-button>										
							</div>
						</div>
					</form>						
				</div>
			</card>
		</div>

		<!-- <card class="post mt-2 focus-shadow">
			<collapse class="row px-3">
				<collapse-item :name="'correktirovka'">	
					<div slot="title" class="col-title">
						<h3 class="mb-0">Корректировки*</h3> 
						<p>*Корректировка может быть отрицательной</p>
					</div>
					<div class="postAddForm mt-2">		
						<form class="form-container">
							<div class="row justify-content-between align-items-center">  
									<div class="col-md mb-3 mt-1">
										<ReInputMask v-model="cor_amount" mask="money" placeholder="Сумма" />
									</div>
									<div class="col-md mb-3">
									<ReInputSearchDrop
										:findId="'agent_id'"
										:placeholder="'Выбрать сотрудника'"
										v-model="cor_staff_code"
										:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
										:strApiMethodKey="'fio'"
										@change="onAgentChange"
									/></div>
									<div class="col-md mb-3 mt-2">
										<base-input
										placeholder="Примечание"
										v-model="cor_comment"
										autocomplete="off"
										></base-input>
									</div>

								<div class="d-flex px-3 mb-3">
									<base-button type="success" simple @click="INS_CORRECT()"><i class="tim-icons icon-send mr-2"></i>Корректировка</base-button>
								</div>
							</div>
						</form>						
					</div>

					

				</collapse-item>
			</collapse>
		</card> -->

		<!--<pre>{{ApiData}}</pre>-->
		<card 
			card-body-classes="table-full-width"
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<div>
				<h4 v-if="this.objApimsg && this.objApimsg!=''" class="text-center"> <i class="tim-icons icon-alert-circle-exc text-danger mb-2 mr-2"></i> {{this.objApimsg}}</h4>

				<el-table :data="ApiData" style="width: 100%;" @sort-change="onSortChange" ref="BillKassaTable">
					<el-table-column
						label="ID"
						property="id"
						width="80"
						sortable
					>
					</el-table-column>
					<el-table-column 
						min-width="180"
						label="Сумма"
						property="amount"
					>
						<template v-slot="scope">{{ $GVO.number_format(scope.row.amount,0,'.',' ') }}</template>
					</el-table-column>
					<el-table-column 
						min-width="180"
						label="Сотрудник"
						property="staff_code"
						sortable
					>
						<template v-slot="scope">
							<router-link :to="'/data/staff/id/'+scope.row.staff_code" v-if="scope.row.staff_fio !=''">{{scope.row.staff_fio}}</router-link>
							<p v-else>{{scope.row.staff_code}}</p>
						</template>
					</el-table-column>
					<el-table-column 
						min-width="180"
						label="Кто провел операцию"
						property="acc_user"
					>
						<template v-slot="scope">
							<router-link :to="'/data/staff/id/'+scope.row.acc_user" v-if="scope.row.acc_user_fio !=''">{{scope.row.acc_user_fio}}</router-link>
							<p v-else>{{scope.row.acc_user}}</p>
						</template>
					</el-table-column>
					<el-table-column 
						min-width="180"
						label="Примечание"
						property="comment"
					>
					</el-table-column>
					<el-table-column 
						min-width="180"
						label="Дата операции"
						property="paydate"
						sortable
					>
						<template v-slot="scope">{{ $GVO.convertDateTimeFromMysql(scope.row.paydate) }}</template>

					</el-table-column>
					
				
					<!--el-table-column
							width="160"
							label="Действие"
							align="right"                    	
					>
							<template slot-scope="scope">			
									<el-tooltip content="Изменить" placement="top">
										<el-button class="no-border my-0">
											<button class="ml-3 btn btn-icon btn-simple btn-success" @click="GoEdit(scope.row)">
												<i class="tim-icons icon-book-bookmark"></i>
											</button>											
										</el-button>
									</el-tooltip>		
									<el-tooltip content="Удалить" placement="top">
										<el-button class="no-border my-0">
											<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
												<i class="tim-icons icon-trash-simple"></i>
											</button>											
										</el-button>
									</el-tooltip>		
							</template>
					</el-table-column-->
				
				</el-table>

			</div>
			<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)" 
				:perPage="parseInt(10)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
// import ReInputMask from "src/our_components/ReInputMask.vue";
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import Pagination from 'src/our_components/RePagination';
// import { Collapse, CollapseItem } from 'src/components';
import ReReportForm from 'src/our_components/ReReportForm.vue';
import ReInputAmount from '../our_components/ReInputAmount.vue';

export default {
	name: 'billkassa-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReInputSearchDrop,
		// ReInputMask,
		ReFilterBtn,
        ReFilter,
		Pagination,
		// Collapse, 
		// CollapseItem,
		ReReportForm,
		ReInputAmount,
		
	},
	data() {
		return {
			ApiData: [],
			objGetParams:{},
			amount: '',
			comment: '',
			staff_code: {inputText: '', selectedVal:''},
			masObjects_total: 0,
			count2page: 10,
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			cor_amount:'',
			cor_comment: '',
			cor_staff_code: {inputText: '', selectedVal:''},
			objSortLoc:{order_field: 'paydate', sortOrder: 'descending'},
			fullscreenLoading: false,
			objApimsg: '',
		};
	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			let sortOrder = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			if (!this.$GVO.isEmpty(this.objSortLoc)) {
				sortOrder = {'order_field':`${this.objSortLoc.order_field} ${this.objSortLoc.sortOrder==='descending'?'desc':'asc'}`}
			}

			this.$GVO.ApiCall('billing.GET_KASSA_PAYMENTS',{flt:{ ...filter,...sortOrder/*,'staff_code':8023*/}})
			//this.$GVO.ApiCall('billing.GET_KASSA_PAYMENTS',{flt:{'c2p':10/*,'staff_code':8023*/}})
			.then((objApi) => {
				if(objApi.success === true){
					this.ApiData = [];
					this.masObjects_total = 0;

					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						//this.masObjects_total = objApi.countpage;
					}
					if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
					this.objApimsg = objApi.msg;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});

		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){ 
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',location.pathname+'?'+strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);			
			this.getApiData();
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('billing.GET_FILTER_KASSA',{})
				.then((objApi) => {
					if(objApi.success){
						//this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		INS_PAYMENT(){
			//console.log('staff_code ' + this.staff_code.selectedVal + ' amount = ' + this.amount);
			this.$GVO.ApiCall('billing.KASSA_PAYMENT',{'iData':{
			 	'amount':this.amount,
			 	'comment':this.comment,
			 	'staff_code': this.staff_code.selectedVal,
				'staff_fio': this.staff_code.inputText,
			 }}).then((objApi) => {
				if(objApi.success){
					this.getApiData();
				}else{
					this.$GVO.showAlert('Редактирование',objApi.msg);
				}
				this.amount='';
				this.comment='';
				this.staff_code={};
			}).catch(errorObjApi => console.error(errorObjApi));
			
		},
		// INS_CORRECT(){
		// 	console.log('staff_code ' + this.cor_staff_code.selectedVal + ' amount = ' + this.cor_amount);
		// 	this.$GVO.ApiCall('billing.INS_CORRECT',{'iData':{
		// 	 	'amount':this.cor_amount,
		// 	 	'comment':this.cor_comment,
		// 	 	'staff_code': this.cor_staff_code.selectedVal,
		// 	 	'staff_fio': this.cor_staff_code.inputText,
		// 	 }}).then((objApi) => {
		// 		if(objApi.success){

		// 		}
		// 		this.cor_amount='';
		// 		this.cor_comment='';
		// 		this.cor_staff_code={};
		// 	}).catch(errorObjApi => console.log(errorObjApi));
		// },
		onAgentChange(data){
			//this.objGetParams['code'] = data.selectedVal;
		},
		onSortChange(objSort){
			this.$emit('sort', objSort);
			this.objSortLoc.order_field = this.$GVO.unlinkObject(objSort.prop);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(objSort.order);
			if(objSort.order != null){
				var queryParams = new URLSearchParams(window.location.search);
				queryParams.set("order_field", objSort.prop);
				queryParams.set("sortOrder", objSort.order);
				history.replaceState(null, null, "?"+queryParams.toString());
				this.objGetParams = this.$GVO.GetAllGet();
				this.OnFilterApply();
			}
		},
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},
		getFilter(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			return filter;
		},
		// reportDownload(){

		// 	const data = {'method':'REPORT_KASSA',obj:'billing',flt:{...this.getFilter()},tags:''};

		// 	this.$GVO.ApiCall('file',{obj:'reports', data})
		// 	.then((objApi) => { 
		// 		if(objApi.success === true){ console.log(objApi);
		// 			if(typeof objApi.file_path != 'undefined' && objApi.file_path != ''){
		// 				window.open(this.$GVO.endpoint_domen+objApi.file_path, '_blank');
		// 			}
		// 		}else{
		// 			// Выдать ошибку?
		// 		}
		// 	}).catch((errorObjApi) => {console.log(errorObjApi); });			
		// }
	},		
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		if(typeof this.objGetParams.order_field != 'undefined'){
			this.objSortLoc.order_field = this.$GVO.unlinkObject(this.objGetParams.order_field);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(this.objGetParams.sortOrder);
			this.$refs.BillKassaTable.sort(this.objSortLoc.prop,this.objSortLoc.order);
		}
		this.getApiData();
		
	}
};
</script>
<style scoped>
.BillKassa {position: relative;}
.BillKassa .post {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
}
/* .BillKassa >>> .post-sticky {position: sticky; top: 15px; z-index: 2;} */
.BillKassa .post >>> .card-body {padding: 0px 5px 15px 10px!important;}
.BillKassa .cancel-note-btn {position: absolute;  top: 0; right: 0;}
.BillKassa .clientPage .card-collapse .post {
	background: #27293d;
}
.BillKassa .white-content .card:not(.card-white) .post {
	background: #fff;
}
.BillKassa .postForm:hover, .focus-shadow  {
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.BillKassa .post h5 {
	margin-bottom: 0px;
}
.BillKassa .form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
.col-title {display: flex; flex-direction: column;}
.BillKassa >>> .el-table .cell {
    word-break: break-word;
}
</style>
